import moment from "moment-timezone"
import { string } from "prop-types"
import { pluralize } from "utils/helpers"

const DuplicationAlert = ({ originalStartsAt, startsAt, openAt, closeAt, showAt, hideAt }) => {
  originalStartsAt = moment(originalStartsAt)
  startsAt = moment(startsAt)
  const dayOffset = startsAt.diff(originalStartsAt, "days")
  const hourOffset = startsAt.diff(originalStartsAt, "hours")
  const minuteOffset = startsAt.diff(originalStartsAt, "minutes")
  const pluralizedDays = pluralize("day", "days", Math.abs(dayOffset), true)
  const pluralizedHours = pluralize("hour", "hours", Math.abs(hourOffset), true)
  const daysString = dayOffset == 0 ? null : pluralizedDays
  const hoursString = hourOffset == 0 ? null : pluralizedHours

  const offsetTime = formattedTime =>
    formattedTime ? moment(formattedTime).add(minuteOffset, "minutes") : null

  openAt = offsetTime(openAt)
  closeAt = offsetTime(closeAt)
  showAt = offsetTime(showAt)
  hideAt = offsetTime(hideAt)

  const offset = daysString || hoursString
  const direction = hourOffset < 0 ? "backward" : "forward"

  const now = moment()
  const registrationState =
    openAt !== null &&
    openAt.isBefore(now) &&
    (closeAt === null || closeAt.isBefore(openAt) || closeAt.isAfter(now))
      ? "open"
      : "closed"

  const visibilityState =
    showAt !== null &&
    showAt.isBefore(now) &&
    (hideAt === null || hideAt.isBefore(showAt) || hideAt.isAfter(now))
      ? "included on"
      : "hidden from"

  const noAdjustmentStatement = "it will be"
  const dateAdjustmentStatement = `all dates will
    be shifted ${direction} ${offset}. That will result in this signup being`

  const signupDateStatement = startsAt.isSame(originalStartsAt)
    ? noAdjustmentStatement
    : dateAdjustmentStatement

  return (
    <div className="alert info-alert mt-3">
      When you create this signup, {signupDateStatement} {registrationState} for registration and{" "}
      {visibilityState} Church Center. You can change these settings after duplication.
    </div>
  )
}

DuplicationAlert.propTypes = {
  originalStartsAt: string.isRequired,
  startsAt: string.isRequired,
  openAt: string,
  closeAt: string,
  showAt: string,
  hideAt: string
}

export default DuplicationAlert
